// Stands in for zod's JSON schema modules (to-json-schema, json-schema-processors, from-json-schema,
// see zod-slim-plugin.js). zod only touches them lazily, so the module graph still works; actually
// converting to or from JSON schema throws.
const unsupported = name => () => {
  throw new Error(`zod ${name} is not available: JSON schema conversion is stripped from the client bundle (config/zod-slim-plugin.js)`);
};

const stubs = {
  __esModule: true, // so zod's `__importStar` hands back this object as is
  // Called when every schema is constructed, they return the (throwing) method
  createToJSONSchemaMethod: () => unsupported('toJSONSchema()'),
  createStandardJSONSchemaMethod: () => unsupported('~standard.jsonSchema'),
  toJSONSchema: unsupported('toJSONSchema()'),
  fromJSONSchema: unsupported('fromJSONSchema()'),
  initializeContext: unsupported('toJSONSchema()'),
  process: unsupported('toJSONSchema()'),
  extractDefs: unsupported('toJSONSchema()'),
  finalize: unsupported('toJSONSchema()'),
};

// `processors.<type>Processor`, looked up per schema type when converting
module.exports = new Proxy(stubs, {
  get: (target, key) => (key in target || typeof key !== 'string' || !key.endsWith('Processor') ?
    target[key] :
    unsupported(key)),
});
